/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { nativeIssueTableEntryPoint } from '@jira/issue-table__issue-table/src/ui/nativeIssueTableEntryPoint.entrypoint.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type IssueNavigatorEmbedEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const issueNavigatorEmbedEntrypoint: EntryPoint<
	IssueNavigatorEmbedEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<IssueNavigatorEmbedEntrypointComponent>(
		/* webpackChunkName: "async-issue-navigator-embed-entrypoint" */ './IssueNavigatorEmbedSPAMemo.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		return {
			entryPoints: {
				nativeIssueTableEntryPoint: {
					entryPoint: nativeIssueTableEntryPoint,
					entryPointParams,
				},
			},
		};
	},
});
